import {
  getAppReaderUrl,
  parseNativeReaderPath,
} from '../packages/content/src/reader-routes'
import { hasNativeDuaBridge } from './nativeDuaBridge'
import { hasNativeQuranBridge } from './nativeQuranBridge'

/** Rewrites trusted in-app reader links only when the native bridge is present. */
export const getNativeReaderHref = (href: string): string => {
  if (typeof window === 'undefined') return href

  let parsedUrl: URL
  try {
    parsedUrl = new URL(href, window.location.origin)
  } catch {
    return href
  }

  if (parsedUrl.origin !== window.location.origin) return href

  const route = parseNativeReaderPath(parsedUrl.pathname)
  if (!route) return href

  const hasBridge = route.kind === 'quran' ? hasNativeQuranBridge() : hasNativeDuaBridge()
  if (!hasBridge) return href

  const appReaderUrl = new URL(
    getAppReaderUrl(route, parsedUrl.hash),
    window.location.origin,
  )
  const section = parsedUrl.searchParams.get('section')
  if (section && /^\d+$/.test(section)) appReaderUrl.searchParams.set('section', section)

  return `${appReaderUrl.pathname}${appReaderUrl.search}${appReaderUrl.hash}`
}
